import type { ContentOperation } from '../types';

/**
 * Return true if the operation has expired.
 */
export function isContentOperationExpired(operation: ContentOperation) {
    const now = Date.now();
    if (now > operation.updatedAt + 1000 * operation.expireAfter) {
        return true;
    }

    return false;
}
